/**
 * Ban lists (TR 601.2.d): Runebound's live `meta_card.banned` list, falling back to the static list
 * below when the live list is unavailable. Names are compared normalised, so promo-name variants in the
 * live list ("Stacked Deck (Origins Nexus Night Promo)", "Draven - Vanquisher") match their cards.
 */
import { normaliseCardName } from './names';

/** Standard ban list as of 2026-09-18 (three waves: 31 Mar, 24 Jul, 18 Sep 2026). */
export const BANNED_STANDARD: readonly string[] = [
  'Scrapheap',
  'Draven, Vanquisher',
  'Called Shot',
  'Fight or Flight',
  'The Dreaming Tree',
  'Obelisk of Power',
  "Reaver's Row",
  'Stealthy Pursuer',
  "The Arena's Greatest",
  "Aspirant's Climb",
  'Ekko, Recurrent',
  'Stacked Deck',
];

/** A resolved ban list and where it came from. */
export interface BanList {
  /** Normalised banned names. */
  names: ReadonlySet<string>;
  source: 'live' | 'static';
}

/** The live list when one is given and non-empty, else the static fallback. */
export function resolveBanList(live?: Iterable<string> | null): BanList {
  const liveNames = live ? [...live].map(normaliseCardName).filter(Boolean) : [];
  if (liveNames.length > 0) return { names: new Set(liveNames), source: 'live' };
  return {
    names: new Set(BANNED_STANDARD.map(normaliseCardName)),
    source: 'static',
  };
}
